var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-view"},[(_vm.ajax.loading)?_c('p',[_vm._v("Loading...")]):(!!_vm.event)?_c('one-event',{attrs:{"event":_vm.event}}):_c('p',[_vm._v("Event not found.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }